module.exports = __webpack_public_path__ + "img/5a7995aa79803393cb39628a64e15650.png";